module.exports = __webpack_public_path__ + "img/mati.13abbe63.jpg";